import { render, staticRenderFns } from "./SignInPerExam.vue?vue&type=template&id=7aff1b24&scoped=true&v-slot%3Acontent=true&"
import script from "./SignInPerExam.vue?vue&type=script&lang=ts&"
export * from "./SignInPerExam.vue?vue&type=script&lang=ts&"
import style0 from "./SignInPerExam.vue?vue&type=style&index=0&id=7aff1b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff1b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
